// LTS TOOL
export const Lts = {
  GET_LTS_INFO: "GET_LTS_INFO",
  GET_LTS_INFO_SUCCESS: "GET_LTS_INFO_SUCCESS",
  GET_LTS_INFO_FAILURE: "GET_LTS_INFO_FAILURE",
  // Reset Data
  RESET_LTS_INFO: "RESET_LTS_INFO",
};
